module.exports = __webpack_public_path__ + "static/media/cy.1c8c0511.svg";